export const customSymbols = {
  AED: 'د.إ', // United Arab Emirates Dirham
  AFN: '؋',   // Afghan Afghani
  ALL: 'L',    // Albanian Lek
  AMD: '֏',   // Armenian Dram
  ANG: 'ƒ',    // Netherlands Antillean Guilder
  AOA: 'Kz',    // Angolan Kwanza
  ARS: '$',    // Argentine Peso
  AUD: '$',    // Australian Dollar
  AWG: 'ƒ',    // Aruban Florin
  AZN: '₼',    // Azerbaijani Manat
  BAM: 'KM',    // Bosnia and Herzegovina Convertible Mark
  BBD: '$',    // Barbadian Dollar
  BDT: '৳',    // Bangladeshi Taka
  BGN: 'лв',   // Bulgarian Lev
  BHD: 'د.ب',   // Bahraini Dinar
  BIF: 'Fr',    // Burundian Franc
  BMD: '$',    // Bermudian Dollar
  BND: '$',    // Brunei Dollar
  BOB: 'Bs.',   // Bolivian Boliviano
  BRL: 'R$',    // Brazilian Real
  BSD: '$',    // Bahamian Dollar
  BTN: 'Nu.',   // Bhutanese Ngultrum
  BWP: 'P',     // Botswana Pula
  BYN: 'Br',    // Belarusian Ruble
  BZD: 'BZ$',   // Belize Dollar
  CAD: 'C$',     // Canadian Dollar
  CDF: 'Fr',    // Congolese Franc
  CHF: 'Fr',    // Swiss Franc
  CLP: '$',     // Chilean Peso
  CNY: '¥',     // Chinese Yuan
  COP: '$',     // Colombian Peso
  CRC: '₡',     // Costa Rican Colón
  CUP: '₱',     // Cuban Peso
  CVE: '$',     // Cape Verdean Escudo
  CZK: 'Kč',    // Czech Koruna
  DJF: 'Fr',    // Djiboutian Franc
  DKK: 'kr',    // Danish Krone
  DOP: 'RD$',   // Dominican Peso
  DZD: 'د.ج',   // Algerian Dinar
  EGP: 'ج.م',   // Egyptian Pound
  ERN: 'Nkf',   // Eritrean Nakfa
  ETB: 'Br',    // Ethiopian Birr
  EUR: '€',     // Euro
  FJD: '$',     // Fijian Dollar
  FKP: '£',     // Falkland Islands Pound
  FOK: 'kr',    // Faroese Króna
  GBP: '£',     // British Pound Sterling
  GEL: '₾',     // Georgian Lari
  GGP: '£',     // Guernsey Pound
  GHS: '₵',     // Ghanaian Cedi
  GIP: '£',     // Gibraltar Pound
  GMD: 'D',     // Gambian Dalasi
  GNF: 'Fr',    // Guinean Franc
  GTQ: 'Q',     // Guatemalan Quetzal
  GYD: '$',     // Guyanese Dollar
  HKD: '$',     // Hong Kong Dollar
  HNL: 'L',     // Honduran Lempira
  HRK: 'kn',    // Croatian Kuna
  HTG: 'G',     // Haitian Gourde
  HUF: 'Ft',    // Hungarian Forint
  IDR: 'Rp',    // Indonesian Rupiah
  ILS: '₪',     // Israeli New Sheqel
  IMP: '£',     // Isle of Man Pound
  INR: '₹',     // Indian Rupee
  IQD: 'ع.د',   // Iraqi Dinar
  IRR: '﷼',    // Iranian Rial
  ISK: 'kr',    // Icelandic Króna
  JEP: '£',     // Jersey Pound
  JMD: '$',     // Jamaican Dollar
  JPY: '¥',     // Japanese Yen
  KES: 'KSh',   // Kenyan Shilling
  KGS: 'с',     // Kyrgyzstani Som
  KHR: '៛',     // Cambodian Riel
  KPW: '₩',     // North Korean Won
  KRW: '₩',     // South Korean Won
  KWD: 'د.ك',   // Kuwaiti Dinar
  KYD: '$',     // Cayman Islands Dollar
  KZT: '₸',     // Kazakhstani Tenge
  LAK: '₭',     // Laotian Kip
  LBP: 'ل.ل',   // Lebanese Pound
  LKR: 'Rs',    // Sri Lankan Rupee
  LRD: '$',     // Liberian Dollar
  LSL: 'M',     // Lesotho Loti
  LYD: 'ل.د',   // Libyan Dinar
  MAD: 'د.م.',   // Moroccan Dirham
  MDL: 'L',     // Moldovan Leu
  MGA: 'Ar',    // Malagasy Ariary
  MKD: 'ден',   // Macedonian Denar
  MMK: 'K',     // Myanmar Kyat
  MNT: '₮',     // Mongolian Tögrög
  MOP: 'P',     // Macanese Pataca
  MRU: 'UM',    // Mauritanian Ouguiya
  MUR: 'Rs',    // Mauritian Rupee
  MVR: 'Rf',    // Maldivian Rufiyaa
  MWK: 'MK',     // Malawian Kwacha
  MXN: '$',     // Mexican Peso
  MYR: 'RM',    // Malaysian Ringgit
  MZN: 'MT',    // Mozambican Metical
  NAD: '$',     // Namibian Dollar
  NGN: '₦',     // Nigerian Naira
  NOK: 'kr',    // Norwegian Krone
  NPR: 'Rs',    // Nepalese Rupee
  NZD: '$',     // New Zealand Dollar
  OMR: 'ر.ع.',   // Omani Rial
  PAB: 'B/.',   // Panamanian Balboa
  PEN: 'S/.',   // Peruvian Sol
  PGK: 'K',     // Papua New Guinean Kina
  PHP: '₱',     // Philippine Peso
  PKR: 'Rs',    // Pakistani Rupee
  PLN: 'zł',    // Polish Zloty
  PYG: '₲',     // Paraguayan Guarani
  QAR: 'ر.ق',   // Qatari Rial
  RON: 'lei',   // Romanian Leu
  RSD: 'дин.',  // Serbian Dinar
  RUB: '₽',     // Russian Ruble
  RWF: 'Fr',    // Rwandan Franc
  SAR: 'ر.س',   // Saudi Riyal
  SBD: '$',     // Solomon Islands Dollar
  SCR: 'Rs',    // Seychellois Rupee
  SDG: 'ج.س',   // Sudanese Pound
  SEK: 'kr',    // Swedish Krona
  SGD: '$',     // Singapore Dollar
  SHP: '£',     // Saint Helena Pound
  SLL: 'Le',    // Sierra Leonean Leone
  SOS: 'S',     // Somali Shilling
  SRD: '$',     // Surinamese Dollar
  SSP: '£',     // South Sudanese Pound
  STN: 'Db',    // São Tomé and Príncipe Dobra
  SVC: '$',     // Salvadoran Colón
  SYP: 'ل.س',   // Syrian Pound
  SZL: 'L',     // Swazi Lilangeni
  THB: '฿',     // Thai Baht
  TJS: 'ЅМ',    // Tajikistani Somoni
  TMT: 'T',     // Turkmenistani Manat
  TND: 'د.ت',   // Tunisian Dinar
  TOP: 'T$',    // Tongan Paʻanga
  TRY: '₺',     // Turkish Lira
  TTD: '$',     // Trinidad and Tobago Dollar
  TWD: 'NT$',   // New Taiwan Dollar
  TZS: 'TSh',   // Tanzanian Shilling
  UAH: '₴',     // Ukrainian Hryvnia
  UGX: 'USh',   // Ugandan Shilling
  USD: '$',     // United States Dollar
  UYU: '$U',    // Uruguayan Peso
  UZS: 'лв',    // Uzbekistani Som
  VEF: 'Bs.F.',  // Venezuelan Bolívar
  VND: '₫',     // Vietnamese Dong
  VUV: 'Vt',    // Vanuatu Vatu
  WST: 'T',     // Samoan Tala
  XAF: 'Fr',    // Central African CFA Franc
  XCD: '$',     // East Caribbean Dollar
  XOF: 'Fr',    // West African CFA Franc
  XPF: 'Fr',    // CFP Franc
  YER: 'ر.ي',   // Yemeni Rial
  ZAR: 'R',     // South African Rand
  ZMW: 'K',     // Zambian Kwacha
  ZWL: '$',     // Zimbabwean Dollar
}; 